<ion-content>
  <ion-grid class="max-w-1400px">
    <ion-row>
      <ion-col>
        <div class="logo">
          <a href="http://www.radimdienst.de">
            <img
              *ngIf="showBusinessLogo"
              src="assets/imgs/color_logo.png"
              alt="Business Logo"
            />
            <img
              *ngIf="!showBusinessLogo"
              src="assets/imgs/logo-1.png"
              alt="Default Logo"
            />
          </a>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-margin-start ion-margin-end ion-margin-bottom">
        <h1 class="text-center color-green">
          Errechnen Sie den Vorteil für Ihr Dienstrad
        </h1>
      </ion-col>
    </ion-row>
    <ion-row class="justify-content-center">
      <ion-col size="12" size-lg="6">
        <div class="content-spanner border-box bg-light-dark">
          <ion-grid>
            <br />
            <ion-row class="pt-2">
              <ion-col class="py-0">
                <ion-item lines="inset">
                  <ion-input
                    #myInput
                    labelPlacement="stacked"
                    label="Dienststellencode / Leasingcode"
                    type="text"
                    style="text-transform: capitalize"
                    [(ngModel)]="inputValue"
                    (focusout)="onInputChange()"
                    placeholder="Ohne Dienststellencode"
                    [autofocus]="true"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Leasingfaktor"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.leasingfaktor"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Übernahmeprozent"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.uebernahmeprozent"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-select
                    label="Fairbetrag Option"
                    labelPlacement="floating"
                    [(ngModel)]="dSS.dienststelle.fairbetrag"
                    (ionChange)="berechnen()"
                  >
                    <ion-select-option [value]="0">pauschaler Zuschuss</ion-select-option>
                    <ion-select-option [value]="1">vertragsindiv. Berechnung, Bezuschussung auch der Leasingrate möglich</ion-select-option>
                    <ion-select-option [value]="2">vollständige Übernahme der monatlichen Versicherungsrate</ion-select-option>
                    <ion-select-option [value]="3">vollständige Übernahme der monatlichen Inspektionsrate</ion-select-option>
                    <ion-select-option [value]="4">vollständige Übernahme der monatlichen Versicherungs- & Inspektionsrate</ion-select-option>
                    <ion-select-option [value]="5">vertragsindiv. Berechnung, Zuschuss bis max. Höhe der Versicherungs- & Inspektionsrate</ion-select-option>
                    <ion-select-option [value]="6">komplette Übernahme der Kosten</ion-select-option>
                    <ion-select-option [value]="7">Arbeitgeberanteil zuzüglich Versicherungs- & Inspektionsrate</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Leasingrate"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="outLeasingrate"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Versicherungsrate"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="outVersAN1"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
            *ngIf="
              dSS.dsCode === 'Kal-radimdienst' ||
              dSS.dsCode === 'Kal-Radimdienst' ||
              dSS.dsCode === 'kal-radimdienst'
            "
          >
            <ion-col>
              <ion-item lines="inset">
                <ion-input
                  label="Inspektionsrate"
                  labelPlacement="floating"
                  type="number"
                  [(ngModel)]="outInspektion"
                  (ionInput)="userEditedInspektion = true"
                  (ngModelChange)="berechnen()"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Arbeitgeberanteil"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.aganteil"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-icon
              class="info_icon_select__position"
              name="information-circle-outline"
              (click)="dSS.showDiv('A')"
            ></ion-icon>
            <div *ngIf="dSS.currInfo=='A'">
              <p class="RIDE-info">
                Den Dienststellen-Code finden Sie auf Ihrem Informationsflyer
                zum Dienstrad-Leasing.
              </p>
            </div>
            <div class="content-spanner">
              <app-ride-fahrrad></app-ride-fahrrad>
            </div>
            <div class="content-spanner">
              <app-ride-beschaefigungsmerkmale></app-ride-beschaefigungsmerkmale>
            </div>

            <div class="content-spanner">
              <app-ride-leasing-rahmenbedingungen></app-ride-leasing-rahmenbedingungen>
            </div>
            <div class="content-spanner">
              <app-ride-schutz-leistung></app-ride-schutz-leistung>
            </div>
          </ion-grid>
          <ion-row class="px-3 small-font">
            <strong>Hinweis</strong>
            <ion-icon
              class="info_icon_select__position"
              name="information-circle-outline"
              (click)="dSS.showDiv('datenschutz')"
            ></ion-icon>
            <div *ngIf="dSS.currInfo == 'datenschutz' ">
              Ihre eingegebenen Daten werden nicht gespeichert oder für andere
              Zwecke verwendet. Weitere Informationen:
              <a href="https://radimdienst.de/datenschutz.php"
                >Datenschutzerklärung</a
              >
            </div>
          </ion-row>
          <ion-col>
            <ion-button class="bg-pink" (click)="modus()">
              {{ dSS.modusErweitert ? 'Einfacher' : 'Erweiterter' }} Modus
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button color="warning" (click)="zuruecksetzen()">
              Zurücksetzen
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button class="bg-green" type="submit" (click)="berechnen()">
              Berechnen
            </ion-button>
          </ion-col>

          <ng-container *ngIf="modusSpezial">
            <div *ngIf="dSS.dienststelle.hasSaving; else noSaving">
              <ion-row>
                <ion-col size="12" size-lg="12">
                  <ion-button
                    expand="block"
                    class="bg-green"
                    (click)="createPDF()"
                  >
                    Als PDF herunterladen
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <div
                    *ngIf="!isValid"
                    class="alert alert-danger alert-dismissible fade show"
                  >
                    <strong>Fehler!</strong> Bitte füllen Sie alle als
                    Pflichtfeld gekennzeichneten Felder aus. 
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="alert"
                    ></button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <div class="border-white">
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Gesamtrate vor Entgeltumwandlung</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start">
                        <p>
                          <b>{{ euro((zvE) - (zvE2))| customCurrency }} </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Tatsächliche Nettobelastung monatlich</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start">
                        <p>
                          <b
                            >{{ monNettoBelastungOhneVorsteuer() |
                            customCurrency }}
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="6">
                        <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                      </ion-col>
                      <ion-col size="6" class="ion-padding-start">
                        <p>
                          <b style="white-space: nowrap"
                            >{{ euro(outErsparnisFix)| customCurrency }} = {{
                            formatNumber(outErsparnisRel) }} %</b
                          >
                        </p>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <ng-template #noSaving>
              <hr />
              <ion-row>
                <ion-col>
                  <div class="border-white">
                    <ion-row>
                      <ion-col size="6">
                        <p><b>monatliche Leasingrate</b></p>
                      </ion-col>
                      <ion-col size="6" class="ion-padding-start">
                        <p>
                          <b
                            >{{ euro((zvE) - (zvE2) + outGwV)| customCurrency }}
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="6">
                        <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                      </ion-col>
                      <ion-col size="6" class="ion-padding-start border-white">
                        <p>
                          <b style="white-space: nowrap"
                            >{{ euro(outGesKostenLZ1) -
                            getNoSavingTotalBikeCost()| customCurrency }} ={{
                            formatNumber(100 - getNoSavingTotalBikeCost() * 100
                            / outGesKostenLZ1) }} %</b
                          >
                        </p>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </ng-template>
            <ion-row>
              <div class="border-white">
                <ion-col size="12">
                  <p>
                    Hinweis: Diese Berechnung ist eine unverbindliche
                    Darstellung der Kostenersparnis.
                  </p>
                </ion-col>
              </div>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-button class="bg-green" (click)="showDetails()">
                  Details
                </ion-button>
              </ion-col>
            </ion-row>
          </ng-container>
        </div>
      </ion-col>
      <!--rechts -->
      <ion-col *ngIf="ergebnis" size="12" size-lg="6">
        <ng-container>
          <!-- Details-->
          <ion-row
            [ngClass]="' max-w-530x content-spanner border-box bg-light-dark'"
          >
            <ion-grid class="ion-margin-start ion-margin-end ion-margin-bottom">
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <h2>Vergleich</h2>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p><b>Direktkauf</b></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>
                    <b
                      >{{ dSS.dienststelle.hasSaving ? 'Entgeltumwandlung' :
                      'Leasingrate' }}</b
                    >
                  </p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="bg-grau"></ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p><b>Bruttomonatsentgelt</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p><b>{{ euro(outBruttoMonat)| customCurrency }}</b></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p><b>{{ euro(outBruttoMonat)| customCurrency }}</b></p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p>Leasingrate</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(outLeasingrate)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p>RadimDienst RadFahrSchutz</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>-{{ euro(outVersAN1) | customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p>RadimDienst Inspektionspaket</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(outInspektion)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="outAGAnteil !== 0">
                <ion-col size="5" class="border-r border-b color-green">
                  <p><b>Fairbetrag</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col
                  size="4"
                  class="border-b ion-padding-start color-green"
                >
                  <p>
                    <b>+ {{ euro(outAGAnteil) | customCurrency }} </b>
                  </p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="dSS.dienststelle.oneProzentNetto == 0">
                <ion-col size="5" class="border-r border-b">
                  <p>MwSt. auf 1% des Ausgangsumsatzes</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(outOnePercent)| customCurrency }}</p>
                </ion-col>
              </ion-row>

              <ion-row class="color-green">
                <ion-col size="5" class="border-r border-b">
                  <p><b>Gesamtrate</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(zvE - zvE2 + outGwV)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="dSS.dienststelle.hasSaving">
                <ion-col size="5" class="border-r border-b color-green">
                  <p>Geldwerter Vorteil (gwV)</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col
                  size="4"
                  class="border-b ion-padding-start color-green"
                >
                  <p>+ {{ euro(outGwV)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <!-- Ab hier Excel Punkte die nicht im Jobrad-Rechner waren -->
              <ion-row>
                <ion-col class="bg-grau"></ion-col>
              </ion-row>
              <div *ngIf="dSS.dienststelle.hasSaving">
                <ion-row class="color-green">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Gesamtumwandlungsrate</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(zvE - zvE2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <!-- Ab hier "normale" Steuerberechnung -->
                <ion-row class="color-green">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Steuer-/SV-pflichtiges Entgelt</b></p>
                  </ion-col>

                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>{{ euro(zvE)| customCurrency }} </b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(zvE2)| customCurrency }} </b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Lohnsteuer</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outlSt1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outlSt2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Solidaritätszuschlag</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ 0| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ 0| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Kirchensteuer</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outKiSt1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outKiSt2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rentenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outRV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outRV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Krankenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outKV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outKV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Pflegeversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outPV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outPV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Arbeitslosenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outAV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outAV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row
                  *ngIf="dSS.dienststelle.oneProzentNetto && dSS.dienststelle.hasSaving"
                >
                  <ion-col size="5" class="border-r border-b">
                    <p>MwSt. auf 1% des Ausgangsumsatzes</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outOnePercentNetto)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Arbeitnehmeranteil Zusatzversorgung (bspw. VBL)</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outVBLbeitrag1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outVBLbeitrag2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>abzüglich geldwerter Vorteil</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outGwV)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Nettoentgelt</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ nettoEntgelt1()|customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ nettoEntgelt2()| customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="dSS.kvValue !== 'gkv'">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Privat Versicherung</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>{{ euro(outpvsumm)| customCurrency }} </b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(outpvsumm)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="dSS.kvValue !=='gkv'">
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Arbeitgeber-Anteil Private Kranken- und
                        Pflegeversicherung</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ euro(outpkvA + dSS.pvAnteil) |customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ euro(outpkvA + dSS.pvAnteil) |customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Auszahlungsbetrag</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ auszahlungsbetrag1()|customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ auszahlungsbetrag2() | customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Tats. monatliche Nettobelastung
                        <span *ngIf="ustAgVar === 2"
                          >ohne Vorsteuerabzugsberechtigung</span
                        >
                      </b>
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ monNettoBelastungOhneVorsteuer()| customCurrency
                        }}</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="ustAgVar === 2 ">
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Tats. monatliche Nettobelastung mit
                        Vorsteuerabzugsberechtigung</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ monNettoBelastungMitVorsteuer() | customCurrency
                        }}</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Übersicht Kosten des Rades</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="ustAgVar !== 2">
                  <ion-col size="5" class="border-r border-b">
                    <p>Summe Nettobelastung über Leasinglaufzeit</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>{{ sumNettoBelastungTotal()| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ng-container *ngIf="ustAgVar === 2 ">
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        Summe Nettobelastung über Leasinglaufzeit ohne
                        Vorsteuerabzugsberechtigung
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{ sumNettoBelastungTotalOhneVorsteuer()|customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        Summe Nettobelastung über Leasinglaufzeit mit
                        Vorsteuerabzugsberechtigung
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{ sumNettoBelastungTotalMitVorsteuer()| customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>Summe Nettobelastung über Leasinglaufzeit Insgesamt</p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ outKaufpreis| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{
                        sumNettoBelastungTotalMitPlusOhneVorsteuer()|customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                </ng-container>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rad-Versicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(getRadVersicherung())| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>inklusive</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Inspektion</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <!--  check for Flex and Basis -->
                    <p>
                      {{ this.euro(this.dSS.dienststelle.sonderInspektion *
                      this.outLeasingduration) |customCurrency }}
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ dSS.dienststelle.inspektion != 0 ? 'Inklusive' : 'Ohne
                      Inspektion' }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b position-relative">
                    <div class="info-label">
                      <b>Übernahmepreis</b>
                      <ion-icon
                        class="info-icon"
                        name="information-circle-outline"
                        (click)="dSS.toggleInfo('G')"
                      ></ion-icon>
                    </div>

                    <div *ngIf="dSS.currInfo === 'G'" class="info-box">
                      <p class="info-text">
                        Im Übernahmepreis enthalten ist der Restwert des Rades
                        (kalkulatorischer Wert für das Dienstrad der
                        Leasingbank, der nicht über die Leasingraten amortisiert
                        wird), der an die Leasingbank abgeführt wird. Außerdem
                        leistet RadimDienst die Pauschalversteuerung des
                        geldwerten Vorteils durch die vergünstigte Übernahme an
                        das zuständige Betriebsstättenfinanzamt.
                      </p>
                    </div>
                  </ion-col>

                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b></b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(uebernahmepreis)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Gesamtkosten (nach {{ outLeasingduration }} Monaten)</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>= {{ euro(outGesKostenLZ1)| customCurrency }}</b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>= {{ euro(outGesKostenLZ2)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ euro(outErsparnisFix)| customCurrency }} ={{
                        formatNumber(outErsparnisRel) }} %</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
              </div>
              <div *ngIf="!dSS.dienststelle.hasSaving">
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Übersicht Kosten des Rades</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Summe Nettobelastung über Leasinglaufzeit</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ euro(outLeasingrate * outLeasingduration)|
                      customCurrency }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rad-Versicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(getRadVersicherung())| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>inklusive</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Inspektion</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <!--  check for Flex and Basis -->
                    <p>
                      {{ this.euro(this.dSS.dienststelle.sonderInspektion *
                      this.outLeasingduration) |customCurrency }}
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ dSS.dienststelle.inspektion != 0 ? 'Inklusive' : 'Ohne
                      Inspektion' }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Übernahmepreis</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b></b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(uebernahmepreis)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <div
                  *ngIf=" euro(outGesKostenLZ1) >= getNoSavingTotalBikeCost()"
                >
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        <b
                          >Gesamtkosten (nach {{ outLeasingduration }}
                          Monaten)</b
                        >
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>
                        <b>= {{ euro(outGesKostenLZ1)| customCurrency }}</b>
                      </p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        <b
                          >= {{ getNoSavingTotalBikeCost()| customCurrency }}</b
                        >
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p></p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        <b
                          >{{ euro(outGesKostenLZ1) -
                          getNoSavingTotalBikeCost()| customCurrency }} = {{
                          formatNumber(100 - getNoSavingTotalBikeCost() * 100 /
                          outGesKostenLZ1) }} %</b
                        >
                      </p>
                    </ion-col>
                  </ion-row>
                </div>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
              </div>
              <ion-row>
                <ion-col class="ion-margin-start">
                  <p>
                    Hinweis: Diese Berechnung ist eine unverbindliche
                    Darstellung der Kostenersparnis.
                  </p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-row>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<!-- use xy-Koordinatensysten to check if calculater works fine

<button (click)="startDiagram()" class="btn btn-secondary">Start</button>
<canvas #chartCanvas width="400" height="auto"></canvas>

-->
